// extracted by mini-css-extract-plugin
export var printerCard = "_j7-1";
export var printerCardConfigured = "_j7-2";
export var printerCardError = "_j7-3";
export var printerCardsContainer = "_j7-0";
export var printerIcon = "_j7-8";
export var printerIconConfigured = "_j7-5";
export var printerIconContainer = "_j7-4";
export var printerIconError = "_j7-6";
export var printerIconUnconfigured = "_j7-7";
export var workstationsTableCard = "_j7-9";